import * as React from "react";
import { Path, Rect, G, Defs, ClipPath, Mask } from "react-native-svg";

import { Icon, IconProps } from "../../primitive";

export const BZIcon = (props: IconProps) => (
  <Icon fill="none" viewBox="0 0 16 12" title="BZ" {...props}>
    <G clipPath="url(#a)">
      <Rect width={16} height={12} fill="#fff" rx={1} />
      <Path
        fill="#0168B4"
        fillRule="evenodd"
        d="M0 0v12h16V0H0Z"
        clipRule="evenodd"
      />
      <Mask
        id="b"
        width={16}
        height={12}
        x={0}
        y={0}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: "luminance",
        }}
      >
        <Path
          fill="#fff"
          fillRule="evenodd"
          d="M0 0v12h16V0H0Z"
          clipRule="evenodd"
        />
      </Mask>
      <G mask="url(#b)">
        <Path
          fill="#E93C43"
          fillRule="evenodd"
          d="M0-.8v2.4h16V-.8H0ZM0 10.4v2.4h16v-2.4H0Z"
          clipRule="evenodd"
        />
        <Path fill="#F7FCFF" d="M8 9a3 3 0 1 1 0-6 3 3 0 0 1 0 6Z" />
        <Path
          fill="#fff"
          d="M8 2.5a3.5 3.5 0 1 1 0 7 3.5 3.5 0 0 1 0-7ZM8 3a3 3 0 1 0 0 6 3 3 0 0 0 0-6Z"
        />
        <Path
          fill="#5B8C39"
          d="M8 3a3 3 0 1 1 0 6 3 3 0 0 1 0-6Zm0 .7a2.3 2.3 0 1 0 0 4.6 2.3 2.3 0 0 0 0-4.6Z"
        />
        <Path
          fill="#5B8C39"
          fillRule="evenodd"
          d="m6.5 7 1.47-.188L9.5 7v.5l-1.53-.188L6.5 7.5V7Z"
          clipRule="evenodd"
        />
        <Path
          fill="#769DF1"
          fillRule="evenodd"
          d="M7 5h2s.141 3-1 3-1-3-1-3Z"
          clipRule="evenodd"
        />
        <Path fill="#FECA00" d="M8 5h1v1H8z" />
        <Path fill="#F6F7F8" d="M7 5h1v1H7z" opacity={0.6} />
        <Rect
          width={2}
          height={1}
          x={7}
          y={4}
          fill="#5B8C39"
          opacity={0.66}
          rx={0.5}
        />
        <Path
          fill="#E9AD35"
          fillRule="evenodd"
          d="M6.9 6.4c.276 0 .5-.448.5-1s-.224-1-.5-1-.5.448-.5 1 .224 1 .5 1Z"
          clipRule="evenodd"
        />
        <Path
          fill="#5C2216"
          fillRule="evenodd"
          d="M9.1 6.4c.276 0 .5-.448.5-1s-.224-1-.5-1-.5.448-.5 1 .224 1 .5 1Z"
          clipRule="evenodd"
        />
      </G>
    </G>
    <Defs>
      <ClipPath id="a">
        <Rect width={16} height={12} fill="#fff" rx={1} />
      </ClipPath>
    </Defs>
  </Icon>
);
